import { FC } from "react";
import styled from "styled-components";

const Container = styled.div(({ theme }) => {
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: `${theme.space[4]} 0`,
    width: "100%",

    "&::before": {
      position: "absolute",
      width: "100%",
      borderTop: `1px solid ${theme.colors.grayLight}`,
      content: '""',
    },
  };
});

const Label = styled.span(({ theme }) => {
  return {
    zIndex: 1,
    padding: `${theme.space[1]} ${theme.space[3]}`,
    borderRadius: 999,
    backgroundColor: theme.colors.primary,
    color: theme.colors.white,
    fontSize: theme.fontSizes[1],
    fontWeight: theme.fontWeights[2],
    lineHeight: theme.lineHeights[1],
    textTransform: "uppercase",
  };
});

export interface OriginSwitchProps {
  /** Text in the pill. Defaults to the operator-joined label. */
  label?: string;
}

/** Divider marking where the conversation changed hands between the chatbot
 * and a team member. */
export const OriginSwitch: FC<OriginSwitchProps> = ({
  label = "Team member online",
}) => {
  return (
    <Container role="status" aria-live="polite">
      <Label>{label}</Label>
    </Container>
  );
};
